import { deClientPortalCreateOrderPagePages } from './Orders/CreateOrder/CreateOrderPage'
import { deClientPortalOrderDetailsPagePages } from './Orders/OrderDetails/OrderDetailsPage'
import { deClientPortalTaskListPagePages } from './Orders/OrderDetails/TaskList/TaskListPage'
import { deClientPortalThreadListPagePages } from './Orders/OrderDetails/ThreadList/ThreadListPage'
import { deClientPortalOrderListPagePages } from './Orders/OrderList/OrderListPage'
import { deClientPortalOrderManagementSidebarPages } from './Orders/OrderManagementSidebar'
import { deClientPortalOrderSidebarPages } from './Orders/OrderSidebar'

export const deClientPortalOrdersPages = {
    orders: {
        ...deClientPortalOrderManagementSidebarPages.orders,
        ...deClientPortalOrderSidebarPages.orders,
        ...deClientPortalCreateOrderPagePages.orders,
        ...deClientPortalOrderListPagePages.orders,
        ...deClientPortalOrderDetailsPagePages.orders,
        ...deClientPortalTaskListPagePages.orders,
        ...deClientPortalThreadListPagePages.orders,
    },
}
